module.exports = __webpack_public_path__ + "static/media/img-7.5f29a91e.png";